import { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { PDFReader } from 'src/components/PDFreader/pdfReader';
import LinkContent from 'src/containers/academy/course/components/LinkContent';
import ReactMarkdown from 'react-markdown';
import { isMobileDevice } from './utils/tableroGestionUtils';
import Quiz from './components/Quiz';

const ContentRenderer = ({
  entry,
  interactions,
  currentUserId,
  onMarkAsRead,
  fetchInteractions,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const playerRef = useRef(null);

  // Handle video play/pause
  const handlePlay = () => {
    setIsPlaying(true);
    if (!isMobileDevice()) {
      setIsMuted(false);
    }
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  // Mobile-specific play handler that unmutes after user interaction
  const handleMobilePlay = () => {
    setIsPlaying(true);
    setTimeout(() => {
      setIsMuted(false);
    }, 100);
  };

  switch (entry.type) {
    case 'video':
      return (
        <div className="video-wrapper">
          <ReactPlayer
            ref={playerRef}
            url={entry.link}
            controls={true}
            playing={isPlaying}
            muted={isMuted}
            onPlay={handlePlay}
            onPause={handlePause}
            style={{
              width: '100%',
              height: isMobileDevice() ? '40vh' : '48vh',
            }}
            playsInline
            config={{
              youtube: {
                playerVars: {
                  autoplay: isPlaying ? 1 : 0,
                  mute: isMuted ? 1 : 0,
                  playsinline: 1,
                  controls: 1,
                  modestbranding: 1,
                  rel: 0,
                  showinfo: 0,
                  iv_load_policy: 3,
                  fs: 1,
                  cc_load_policy: 0,
                  start: 0,
                  end: 0,
                },
              },
            }}
          />
          {!isPlaying && (
            <button
              className="play-overlay"
              onClick={isMobileDevice() ? handleMobilePlay : () => setIsPlaying(true)}
              aria-label="Play video"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
            </button>
          )}
        </div>
      );
    case 'pdf':
      return (
        <div>
          <PDFReader url={entry.link} />
          <LinkContent link={entry.link} />
          {entry.content && (
            <div className="text-content">
              <ReactMarkdown>{entry.content}</ReactMarkdown>
            </div>
          )}
        </div>
      );
    case 'link':
      return (
        <div>
          {entry.content && (
            <div className="text-content">
              <ReactMarkdown>{entry.content}</ReactMarkdown>
            </div>
          )}
          <LinkContent link={entry.link} textCTA="ABRIR" />
        </div>
      );
    case 'quiz':
      return (
        <Quiz
          entry={entry}
          interactions={interactions}
          currentUserId={currentUserId}
          onMarkAsRead={onMarkAsRead}
          fetchInteractions={fetchInteractions}
        />
      );
    case 'text':
    default:
      return (
        <div className="text-content">
          <ReactMarkdown>{entry.content || ''}</ReactMarkdown>
        </div>
      );
  }
};

export default ContentRenderer;
